export const landingPagePatches = {
    es: {
        /** Site title stays English (`public/pages/landing.json`) — do not translate “West Virginia”. */
        title: 'West Virginia One Stop Shop',
        sections: {
            'landing-hero': {
                title: 'West Virginia One Stop Shop',
                titleImageAlt: 'West Virginia One Stop Shop',
                subheading: 'Permisos y licencias en un solo lugar',
                description: 'Descubra un mundo nuevo de permisos, licencias y servicios regulatorios de todos los departamentos de West Virginia. Encuentre exactamente lo que necesita de forma rápida y sencilla.',
                searchPlaceholder: 'Buscar…',
                searchButtonLabel: 'Buscar',
                agenciesHeading: 'Agencias',
                agenciesSubheading: 'Seleccione una agencia para ver servicios y enlaces.',
                departmentsHeading: 'Departamentos',
                departmentsSubheading: 'Elija un departamento para ver permisos y servicios.',
                nav: {
                    logoText: 'West Virginia',
                    links: [
                        { label: 'Inicio', href: '#hero' },
                        { label: 'Sobre nosotros', href: '#why-choose' },
                        { label: 'Agencias', href: '#agencies' },
                        { label: 'Departamentos', href: '#departments' },
                        { label: 'Cómo funciona', href: '#how-it-works' },
                    ],
                    loginLabel: 'Iniciar sesión',
                    loginHref: '/login',
                    ctaLabel: 'Registrarse',
                    ctaHref: '/register',
                },
                features: [
                    { icon: 'Speed', title: 'Rápido y fácil', subtitle: 'Proceso de solicitud ágil' },
                    { icon: 'VerifiedUser', title: 'Seguro', subtitle: 'Sus datos están protegidos' },
                    { icon: 'AccessTime', title: 'Disponible 24/7', subtitle: 'Acceda en cualquier momento y lugar' },
                ],
                departments: [
                    {
                        title: 'Negocios',
                        recordId: 'commerce',
                        href: '/permits/commerce',
                        image: '/images/WestVirginia/2026.03.27_One-Stop Shop Website/013_FifeBrewery_220823_2615.webp',
                        imageAlt: 'Charleston centro',
                        icon: 'Business',
                        matchTitles: ['Commerce', 'Department of Commerce'],
                    },
                    {
                        title: 'Bienes raíces',
                        recordId: 'revenue',
                        href: '/permits/revenue',
                        image: '',
                        icon: 'AccountBalance',
                    },
                    {
                        title: 'Salud',
                        recordId: 'health',
                        href: '/permits/health',
                        image: '',
                        icon: 'Assignment',
                    },
                    {
                        title: 'Industria',
                        recordId: 'env',
                        href: '/permits/env',
                        image: '/images/WestVirginia/2026.03.27_One-Stop Shop Website/C.-Loomis-New-River-Gorge-LR--4-.webp',
                        imageAlt: 'New River Gorge',
                        icon: 'Forest',
                        matchTitles: [
                            'Department of Environmental Protection',
                            'Environmental Protection',
                            'Environment',
                            'Industry',
                        ],
                    },
                    {
                        title: 'Transporte',
                        recordId: 'transportation',
                        href: '/permits/transportation',
                        image: '/images/WestVirginia/2026.03.27_One-Stop Shop Website/DJI_0036.webp',
                        imageAlt: 'Intercambio de Charleston y río Kanawha',
                        icon: 'AccountBalance',
                        matchTitles: ['Transportation', 'Infrastructure', 'Department of Transportation'],
                    },
                ],
            },
            'get-started': {
                heading: 'Comience rápido',
                subheading: 'Siga unos pasos sencillos y encuentre el permiso o la licencia adecuados para sus necesidades. Lo hemos hecho más fácil que nunca.',
                items: [
                    {
                        icon: 'Assignment',
                        title: 'Iniciar un permiso nuevo',
                        description: 'Comience una solicitud nueva con pasos claros y guiados.',
                        href: '/apply',
                        accent: 'amber',
                    },
                    {
                        icon: 'CheckBox',
                        title: 'Consultar el estado de la solicitud',
                        description: 'Vea en qué etapa está su permiso y qué hacer a continuación.',
                        href: '/status',
                        accent: 'green',
                    },
                    {
                        icon: 'Security',
                        title: 'Inicio de sesión único (SSO)',
                        description: 'Acceda de forma segura con la cuenta de su organización.',
                        href: '/login',
                        accent: 'gold',
                    },
                ],
            },
            'how-it-works-section': {
                heading: 'Cómo funciona',
                subheading: 'Nuestro proceso en cuatro pasos está diseñado para ser simple y eficiente, guiándole en cada etapa de su solicitud de permiso o licencia.',
                steps: [
                    {
                        title: 'Seleccionar departamento',
                        description: 'Elija el departamento correspondiente a su permiso o licencia.',
                        icon: 'AccountBalance',
                    },
                    {
                        title: 'Preparar agencias',
                        description: 'Reúna todos los documentos e información necesarios para su solicitud.',
                        icon: 'Groups',
                    },
                    {
                        title: 'Revisar requisitos',
                        description: 'Revise con atención los requisitos y pautas de su permiso específico.',
                        icon: 'Description',
                    },
                    {
                        title: 'Enviar la solicitud',
                        description: 'Complete y envíe su solicitud a través de nuestro portal seguro en línea.',
                        icon: 'Assignment',
                    },
                ],
            },
            'why-choose': {
                heading: '¿Por qué elegir la tienda única?',
                subheading: 'Descubra por qué miles de empresas y personas confían en nosotros para sus permisos y licencias. Ofrecemos una experiencia fluida y confiable.',
                imageAlt: 'Río Kanawha y Capitolio estatal de West Virginia, Charleston',
                items: [
                    {
                        icon: 'Speed',
                        title: 'Ahorre tiempo',
                        description: 'Nuestro proceso simplificado le ahorra tiempo y esfuerzo.',
                    },
                    {
                        icon: 'VerifiedUser',
                        title: 'Seguro',
                        description: 'Utilizamos las mejores medidas de seguridad para proteger su información.',
                    },
                    {
                        icon: 'AccessTime',
                        title: 'Disponible 24/7',
                        description: 'Acceda a nuestros servicios en cualquier momento y desde cualquier lugar.',
                    },
                    {
                        icon: 'TrendingUp',
                        title: 'Seguimiento en tiempo real',
                        description: 'Supervise el estado de sus solicitudes con nuestro sistema de seguimiento.',
                    },
                    {
                        icon: 'Help',
                        title: 'Soporte experto',
                        description: 'Nuestro equipo está disponible para ayudarle con sus dudas o incidencias.',
                    },
                    {
                        icon: 'CheckCircle',
                        title: 'Proceso sencillo',
                        description: 'Una interfaz clara hace que todo el trámite sea directo y comprensible.',
                    },
                ],
            },
            'stats-bar': {
                items: [
                    { value: '5', label: 'DEPARTAMENTOS' },
                    { value: '19', label: 'AGENCIAS ACTIVAS' },
                    { value: '100+', label: 'PERMISOS DISPONIBLES' },
                    { value: '24/7', label: 'SOPORTE EN LÍNEA' },
                ],
            },
            faq: {
                label: 'Preguntas frecuentes',
                items: [
                    {
                        question: '¿Qué permisos necesito para mi negocio?',
                        answer: 'Los permisos dependen del tipo de negocio y la ubicación. Use la búsqueda para encontrar los requisitos específicos de su sector.',
                    },
                    {
                        question: '¿Cuánto tarda la aprobación?',
                        answer: 'Los plazos varían según el tipo de permiso y el departamento. Puede seguir el estado de su solicitud en tiempo real en el portal.',
                    },
                    {
                        question: '¿Puedo solicitar varios permisos a la vez?',
                        answer: 'Sí, el sistema le permite solicitar varios permisos y licencias al mismo tiempo para agilizar el proceso.',
                    },
                    {
                        question: '¿Qué métodos de pago aceptan?',
                        answer: 'Aceptamos diversos métodos de pago, incluidas tarjetas y transferencias electrónicas, a través de nuestro portal seguro.',
                    },
                ],
            },
            cta: {
                heading: '¿Listo para comenzar?',
                description: 'Explore nuestros departamentos y encuentre los permisos y licencias que su negocio necesita.',
                buttonLabel: 'Ver departamentos',
                buttonHref: '#departments',
                secondaryButtonLabel: 'Soporte del portal',
                secondaryButtonHref: 'mailto:speedtobuildsupport@delasoft.com',
                additionalButtons: [{ label: 'Contactos de agencias', href: '/agency-contacts' }],
                sectionBackground: '#ffffff',
            },
            footer: {
                logoText: '',
                description: 'Sitio web oficial del Estado de West Virginia.',
                linkGroups: [
                    {
                        title: '',
                        links: [
                            { label: 'Inicio', href: '#hero' },
                            { label: 'Sobre nosotros', href: '#why-choose' },
                            { label: 'Agencias', href: '#agencies' },
                            { label: 'Departamentos', href: '#departments' },
                            { label: 'Cómo funciona', href: '#how-it-works' },
                        ],
                    },
                    {
                        title: '',
                        links: [
                            { label: 'Privacidad de West Virginia', href: 'https://www.wv.gov/privacy-policy', openInNewTab: true },
                            {
                                label: 'Oficina de Tecnología de West Virginia - Políticas y normas',
                                href: 'https://technology.wv.gov/policy-governance/ot-policies',
                                openInNewTab: true,
                            },
                            {
                                label: 'Oficina Estatal de Privacidad de West Virginia - Políticas de privacidad',
                                href: 'https://brim.wv.gov/privacy/privacy-policies',
                                openInNewTab: true,
                            },
                            { label: 'Términos del servicio', href: '/terms' },
                        ],
                    },
                ],
                copyright: '© 2026 West Virginia One Stop Shop. Todos los derechos reservados.',
            },
        },
    },
};
